"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _Note = _interopRequireWildcard(require("../../Notes/Note"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _DatePicker = _interopRequireDefault(require("../../../DatePicker"));
var _NightsPicker = require("../../../NightsPicker");
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _PriceField = _interopRequireDefault(require("../../../PriceField"));
var _TouristsPicker = require("../../../TouristsPicker");
var _iconsReact = require("../../../../icons-react");
var _tagsSelect = require("../../../../icons-react/tags-select");
var _userflow = require("../../../../utils/userflow");
var _excluded = ["adults", "cityFromId", "dates", "comment", "destination", "isNightsFlex", "kids", "nights", "onChange", "options", "partnerId", "hotelMealId", "price", "segmentId", "sourceId", "onGoToLeadMailer"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledDepartureDatesButton = _DatePicker["default"].StyledButton;
var StyledNightsInput = _NightsPicker.NightsPickerOld.Input;
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX,
  StyledSelectorSearchIcon = _Selector["default"].StyledSearchIcon,
  StyledSelectorValue = _Selector["default"].StyledValue,
  optionPropTypes = _Selector["default"].optionPropTypes;
var DATE_FORMAT = 'd MMM';
var NIGHT_WORD_FORMS = ['ночь', 'ночи', 'ночей'];
var AGE_WORD_FORMS = ['год', 'года', 'лет'];
var ADULT_WORD_FORMS = ['взрослый', 'взрослых', 'взрослых'];
var KID_WORD_FORMS = ['ребёнок', 'ребёнка', 'ребёнка'];
var DEFAULT_ADULTS = 2;
var StyledOpenIcon = (0, _styledComponents["default"])(_tagsSelect.Open).withConfig({
  displayName: "TourSelectionForm__StyledOpenIcon",
  componentId: "sc-1wme9v3-0"
})(["flex-shrink:0;height:6px;margin-left:9px;margin-top:2px;width:10px;"]);
var filterDepartureDate = function filterDepartureDate(date) {
  return date >= Date.now();
};
var TourSelectionForm = /*#__PURE__*/function (_React$PureComponent) {
  function TourSelectionForm(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TourSelectionForm);
    _this = _callSuper(this, TourSelectionForm, [props]);
    var destinationQuery = (0, _get2["default"])(props, 'destination.label') || '';
    _this.state = {
      destinationFocused: false,
      destinationQuery: destinationQuery
    };
    _this.nightsRenderer = _this.nightsRenderer.bind(_this);
    _this.touristsRenderer = _this.touristsRenderer.bind(_this);
    _this.handleDestinationInput = _this.handleDestinationInput.bind(_this);
    _this.handleDestinationFocus = _this.handleDestinationFocus.bind(_this);
    _this.handleDestinationKeyDown = _this.handleDestinationKeyDown.bind(_this);
    _this.destinationRenderer = _this.destinationRenderer.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TourSelectionForm, _React$PureComponent);
  return (0, _createClass2["default"])(TourSelectionForm, [{
    key: "handleDestinationFocus",
    value: function handleDestinationFocus(destinationFocused) {
      var destination = this.props.destination;
      var destinationQuery = (0, _get2["default"])(destination, 'label') || '';
      this.setState({
        destinationQuery: destinationQuery,
        destinationFocused: destinationFocused
      });
    }
  }, {
    key: "handleDestinationKeyDown",
    value: function handleDestinationKeyDown(event) {
      if (event.which === 32) {
        event.stopPropagation();
      }
    }
  }, {
    key: "handleDestinationInput",
    value: function handleDestinationInput(_ref) {
      var currentTarget = _ref.currentTarget;
      var value = currentTarget.value;
      var _this$props = this.props,
        options = _this$props.options,
        onDestinationInput = _this$props.onDestinationInput;
      var SPLITTER = ' ';
      var countryId;
      var query = value;
      if (value.includes(SPLITTER)) {
        var _value$split = value.split(SPLITTER),
          _value$split2 = (0, _slicedToArray2["default"])(_value$split, 2),
          countryLabel = _value$split2[0],
          splittedQuery = _value$split2[1];
        var countries = options.countries;
        var country = countries.find(function (_ref2) {
          var label = _ref2.label;
          var loweredLabel = label.toLowerCase();
          var loweredQuery = countryLabel.toLowerCase();
          return loweredQuery.includes(loweredLabel);
        });
        countryId = (0, _get2["default"])(country, 'id');
        if (countryId) {
          query = splittedQuery;
        }
      }
      this.setState({
        destinationQuery: value
      }, function () {
        if ((0, _size2["default"])(value) > 0) {
          onDestinationInput({
            query: query,
            countryId: countryId
          });
        }
      });
    }
  }, {
    key: "touristsRenderer",
    value: function touristsRenderer() {
      var _this$props2 = this.props,
        adults = _this$props2.adults,
        kids = _this$props2.kids;
      var isFilled = Boolean(adults);
      var placeholder = 'Туристы';
      var adultsRenderer;
      var kidsRenderer;
      if (adults) {
        var adultLabel = (0, _userflow.pluralize)(adults, ADULT_WORD_FORMS);
        adultsRenderer = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, adults), adultLabel);
      }
      if (kids) {
        var kidsCount = kids.length;
        var kidsCountLabel = (0, _userflow.pluralize)(kidsCount, KID_WORD_FORMS);
        var ages = kids.join(', ');
        var lastAge = kids[kids.length - 1];
        var lastAgeLabel = (0, _userflow.pluralize)(lastAge, AGE_WORD_FORMS);
        kidsRenderer = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ",\xA0", /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, kidsCount), kidsCountLabel, "\xA0 (", /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, ages), lastAgeLabel, ")");
      }
      return /*#__PURE__*/_react["default"].createElement(StyledFieldLabel, {
        filled: isFilled
      }, !isFilled && placeholder, adultsRenderer, kidsRenderer, /*#__PURE__*/_react["default"].createElement(StyledOpenIcon, null));
    }
  }, {
    key: "nightsRenderer",
    value: function nightsRenderer() {
      var _this$props3 = this.props,
        isNightsFlex = _this$props3.isNightsFlex,
        nights = _this$props3.nights;
      var placeholder = 'Диапазон ночей';
      var filled = Boolean(nights);
      var count = isNightsFlex ? "".concat(nights - 2, " \u2013 ").concat(nights + 2) : nights;
      var label = (0, _userflow.pluralize)(isNightsFlex ? nights + 2 : nights, NIGHT_WORD_FORMS);
      return /*#__PURE__*/_react["default"].createElement(StyledNightsLabel, {
        filled: filled
      }, filled ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, count), label) : placeholder, /*#__PURE__*/_react["default"].createElement(StyledOpenIcon, null));
    }
  }, {
    key: "destinationRenderer",
    value: function destinationRenderer(_ref3) {
      var _this2 = this;
      var selectProps = _ref3.selectProps;
      var _this$state = this.state,
        destinationFocused = _this$state.destinationFocused,
        destinationQuery = _this$state.destinationQuery;
      var placeholder = selectProps.placeholder;
      var value = (0, _get2["default"])(selectProps, 'value.label');
      return /*#__PURE__*/_react["default"].createElement(StyledDestinationInput, {
        key: value,
        placeholder: placeholder,
        autoFocus: destinationFocused,
        onClick: function onClick() {
          return _this2.handleDestinationFocus(true);
        },
        value: destinationFocused ? destinationQuery : value,
        onInput: this.handleDestinationInput,
        onKeyDown: this.handleDestinationKeyDown,
        onBlur: function onBlur() {
          return _this2.handleDestinationFocus(false);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        adults = _this$props4.adults,
        cityFromId = _this$props4.cityFromId,
        dates = _this$props4.dates,
        comment = _this$props4.comment,
        destination = _this$props4.destination,
        isNightsFlex = _this$props4.isNightsFlex,
        kids = _this$props4.kids,
        nights = _this$props4.nights,
        _onChange = _this$props4.onChange,
        options = _this$props4.options,
        partnerId = _this$props4.partnerId,
        hotelMealId = _this$props4.hotelMealId,
        price = _this$props4.price,
        segmentId = _this$props4.segmentId,
        sourceId = _this$props4.sourceId,
        onGoToLeadMailer = _this$props4.onGoToLeadMailer,
        props = (0, _objectWithoutProperties2["default"])(_this$props4, _excluded);
      var _this$state2 = this.state,
        destinationQuery = _this$state2.destinationQuery,
        destinationFocused = _this$state2.destinationFocused;
      var countries = options.countries,
        hotelMeals = options.hotelMeals,
        departures = options.departures,
        destinations = options.destinations,
        partners = options.partners,
        segments = options.segments,
        sources = options.sources;
      var destinationOptions = (0, _size2["default"])(destinationQuery) > 0 ? destinations : countries;
      if (destination && (0, _isEmpty2["default"])(destinationOptions)) {
        var isInitialQuery = (0, _get2["default"])(destination, 'label') === destinationQuery;
        if (isInitialQuery) {
          destinationOptions = [destination];
        }
      }
      return /*#__PURE__*/_react["default"].createElement(StyledTourSelectionForm, props, /*#__PURE__*/_react["default"].createElement(StyledHeadline, null, "\u041F\u043E\u0434\u0431\u043E\u0440 \u0442\u0443\u0440\u0430", /*#__PURE__*/_react["default"].createElement(StyledGoToLeadMailerIcon, {
        onClick: onGoToLeadMailer
      })), /*#__PURE__*/_react["default"].createElement(StyledDeparutes, {
        isSearchable: true,
        onChange: function onChange(option) {
          return _onChange('cityFromId', option.value);
        },
        options: departures,
        placeholder: "\u0413\u043E\u0440\u043E\u0434 \u0432\u044B\u043B\u0435\u0442\u0430",
        value: (0, _find2["default"])(departures, {
          value: cityFromId
        })
      }), /*#__PURE__*/_react["default"].createElement(StyledDestinations, {
        isSearchable: true,
        menuIsOpen: destinationFocused,
        onChange: function onChange(option) {
          _this3.setState({
            destinationQuery: option.label,
            destinationFocused: false
          }, function () {
            return _onChange('destination', option);
          });
        },
        backspaceRemovesValue: false,
        options: destinationOptions,
        placeholder: "\u0421\u0442\u0440\u0430\u043D\u0430, \u0433\u043E\u0440\u043E\u0434 \u0438\u043B\u0438 \u043E\u0442\u0435\u043B\u044C \u0434\u043B\u044F \u043E\u0442\u0434\u044B\u0445\u0430",
        value: destination,
        components: {
          Input: this.destinationRenderer,
          SingleValue: function SingleValue() {
            return _react["default"].Fragment;
          },
          Placeholder: function Placeholder() {
            return _react["default"].Fragment;
          }
        }
      }), /*#__PURE__*/_react["default"].createElement(StyledDepratureDates, {
        functional: true,
        isDatesExist: !(0, _isEmpty2["default"])(dates)
      }, /*#__PURE__*/_react["default"].createElement(StyledDatePicker, {
        key: dates,
        dateFormat: DATE_FORMAT,
        filterDate: filterDepartureDate,
        multiple: true,
        onChange: function onChange(value) {
          return _onChange('dates', value);
        },
        placeholder: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0432\u044B\u043B\u0435\u0442\u0430",
        value: dates
      }), /*#__PURE__*/_react["default"].createElement(StyledOpenIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledNights, {
        flex: isNightsFlex,
        LabelComponent: this.nightsRenderer,
        onChange: function onChange(value) {
          return _onChange('nights', value);
        },
        onChangeFlex: function onChangeFlex() {
          return _onChange('isNightsFlex', !isNightsFlex);
        },
        value: nights || 7
      }), /*#__PURE__*/_react["default"].createElement(StyledHotelMeals, {
        isSearchable: true,
        onChange: function onChange(option) {
          return _onChange('hotelMealId', option.value);
        },
        options: hotelMeals,
        placeholder: "\u041F\u0438\u0442\u0430\u043D\u0438\u0435",
        value: (0, _find2["default"])(hotelMeals, {
          value: hotelMealId
        })
      }), /*#__PURE__*/_react["default"].createElement(_PriceField["default"], {
        value: price,
        maxLength: 9,
        onChange: function onChange(value) {
          return _onChange('price', value);
        },
        placeholder: "\u0411\u044E\u0434\u0436\u0435\u0442"
      }), /*#__PURE__*/_react["default"].createElement(_TouristsPicker.TouristsPickerOld, {
        value: adults || DEFAULT_ADULTS,
        kidsValue: kids || [],
        onChange: function onChange(value) {
          return _onChange('adults', value);
        },
        onChangeKids: function onChangeKids(value) {
          if (!adults) {
            _onChange('adults', DEFAULT_ADULTS);
          }
          _onChange('kids', value);
        },
        LabelComponent: this.touristsRenderer
      }), /*#__PURE__*/_react["default"].createElement(StyledField, {
        isSearchable: true,
        onChange: function onChange(option) {
          return _onChange('sourceId', option.value);
        },
        options: sources,
        placeholder: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
        value: (0, _find2["default"])(sources, {
          value: sourceId
        })
      }), /*#__PURE__*/_react["default"].createElement(StyledField, {
        isSearchable: true,
        multiple: true,
        onChange: function onChange(option) {
          return _onChange('partnerId', option.value);
        },
        options: partners,
        placeholder: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
        value: (0, _find2["default"])(partners, {
          value: partnerId
        })
      }), /*#__PURE__*/_react["default"].createElement(StyledField, {
        isSearchable: true,
        onChange: function onChange(option) {
          return _onChange('segmentId', option.value);
        },
        options: segments,
        placeholder: "\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u0433\u0440\u0443\u043F\u043F\u0430",
        value: (0, _find2["default"])(segments, {
          value: segmentId
        })
      }), /*#__PURE__*/_react["default"].createElement(StyledNote, {
        disableHead: true,
        value: comment || '',
        placeholder: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u043C\u0435\u0442\u043A\u0443 \u043A \u0442\u0438\u043A\u0435\u0442\u0443",
        onEdit: function onEdit(_ref4) {
          var value = _ref4.value;
          return _onChange('comment', value);
        }
      }));
    }
  }]);
}(_react["default"].PureComponent);
var optionsPropTypes = _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread({}, optionPropTypes)).isRequired).isRequired;
TourSelectionForm.propTypes = {
  className: _propTypes["default"].string,
  adults: _propTypes["default"].number,
  comment: _propTypes["default"].string,
  cityFromId: _propTypes["default"].string,
  dates: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
  destination: _propTypes["default"].shape(_objectSpread({}, optionPropTypes)),
  options: {
    countries: optionsPropTypes,
    departures: optionsPropTypes,
    destinations: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, optionPropTypes), {}, {
      country: _propTypes["default"].string
    })).isRequired).isRequired,
    hotelMeals: optionsPropTypes,
    sources: optionsPropTypes,
    partners: optionsPropTypes,
    segments: optionsPropTypes
  },
  isNightsFlex: _propTypes["default"].bool,
  kids: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired),
  nights: _propTypes["default"].number,
  hotelMealId: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onDestinationInput: _propTypes["default"].func,
  price: _propTypes["default"].number,
  sourceId: _propTypes["default"].string,
  segmentId: _propTypes["default"].string,
  partnerId: _propTypes["default"].string,
  onGoToLeadMailer: _propTypes["default"].func
};
TourSelectionForm.defaultProps = {
  className: '',
  onChange: Function.prototype,
  onDestinationInput: Function.prototype,
  onGoToLeadMailer: Function.prototype,
  options: {
    departures: [],
    destinations: [],
    hotelMeals: [],
    partners: [],
    segments: [],
    sources: []
  }
};
var StyledTourSelectionForm = _styledComponents["default"].form.withConfig({
  displayName: "TourSelectionForm__StyledTourSelectionForm",
  componentId: "sc-1wme9v3-1"
})(["display:flex;flex-direction:column;"]);
var StyledHeadline = _styledComponents["default"].div.withConfig({
  displayName: "TourSelectionForm__StyledHeadline",
  componentId: "sc-1wme9v3-2"
})(["display:flex;align-items:center;justify-content:space-between;color:#919499;font-size:12px;"]);
var StyledHighlight = _styledComponents["default"].span.withConfig({
  displayName: "TourSelectionForm__StyledHighlight",
  componentId: "sc-1wme9v3-3"
})(["margin-right:4px;"]);
var StyledDestinationInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "TourSelectionForm__StyledDestinationInput",
  componentId: "sc-1wme9v3-4"
})(["height:25px;font-size:14px;line-height:25px;outline:none;padding:0;border:none;background:none;width:min-content;display:flex;:focus{cursor:input;color:#007aff;}:hover{cursor:pointer;}"]);
var StyledField = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TourSelectionForm__StyledField",
  componentId: "sc-1wme9v3-5"
})(["cursor:pointer;input{color:#007aff !important;}.", "__placeholder{color:#919499;}.", "__single-value{height:auto;line-height:normal;margin:0;span{color:#17181a;}}", "{flex:1;}", "{display:none;margin:4px 0 0;padding:0;}", "{color:#17181a !important;}:hover{.", "__single-value,.", "__placeholder{color:#007aff;span{color:#007aff;}}", "{color:#007aff !important;}", "{display:block;}}"], CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, StyledSelectorValue, StyledSelectorSearchIcon, StyledDestinationInput, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, StyledDestinationInput, StyledSelectorSearchIcon);
var StyledFieldLabel = _styledComponents["default"].div.withConfig({
  displayName: "TourSelectionForm__StyledFieldLabel",
  componentId: "sc-1wme9v3-6"
})(["color:", ";cursor:pointer;display:flex;font-size:14px;line-height:25px;position:relative;", "{display:none;margin-top:12px;margin-left:9px;}", "{display:none;margin-left:9px;}:hover{color:#919499;", "{display:block;}", "{display:block;}", "{color:#007aff;}}"], function (props) {
  return props.filled ? 'black' : '#919499';
}, StyledOpenIcon, StyledSelectorSearchIcon, StyledOpenIcon, StyledSelectorSearchIcon, StyledHighlight);
var StyledDeparutes = (0, _styledComponents["default"])(StyledField).withConfig({
  displayName: "TourSelectionForm__StyledDeparutes",
  componentId: "sc-1wme9v3-7"
})([""]);
var StyledDestinations = (0, _styledComponents["default"])(StyledField).withConfig({
  displayName: "TourSelectionForm__StyledDestinations",
  componentId: "sc-1wme9v3-8"
})(["font-size:14px;input{width:calc(100% - 20px);text-overflow:ellipsis;white-space:nowrap;::placeholder{color:#919499;}}.", "__value-container{flex:1;}", "{display:none;}"], CLASS_NAME_PREFIX, StyledSelectorValue);
var StyledHotelMeals = (0, _styledComponents["default"])(StyledField).withConfig({
  displayName: "TourSelectionForm__StyledHotelMeals",
  componentId: "sc-1wme9v3-9"
})([""]);
var StyledDepratureDates = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TourSelectionForm__StyledDepratureDates",
  componentId: "sc-1wme9v3-10"
})(["align-items:center;color:", ";cursor:pointer;display:flex;outline:none;position:relative;", "{background-color:transparent;color:inherit;height:auto;outline:none;padding:0;line-height:25px;}", "{display:none;}:hover{color:#007aff;", "{display:block;}}"], function (props) {
  return props.isDatesExist ? 'black' : '#919499';
}, StyledDepartureDatesButton, StyledOpenIcon, StyledOpenIcon);
var StyledDatePicker = (0, _styledComponents["default"])(_DatePicker["default"]).withConfig({
  displayName: "TourSelectionForm__StyledDatePicker",
  componentId: "sc-1wme9v3-11"
})(["height:25px;"]);
var StyledNightsLabel = _styledComponents["default"].div.withConfig({
  displayName: "TourSelectionForm__StyledNightsLabel",
  componentId: "sc-1wme9v3-12"
})(["align-items:center;color:", ";cursor:pointer;display:flex;font-size:14px;line-height:25px;"], function (props) {
  return props.filled ? 'black' : '#919499';
});
var StyledNights = (0, _styledComponents["default"])(_NightsPicker.NightsPickerOld).withConfig({
  displayName: "TourSelectionForm__StyledNights",
  componentId: "sc-1wme9v3-13"
})(["", "{background-color:transparent;box-shadow:none;cursor:pointer;height:auto;padding:0;svg{display:none;}}", "{display:none;}:hover{", "{color:#919499;", "{display:block;}", "{color:#007aff;}}}"], StyledNightsInput, StyledOpenIcon, StyledNightsLabel, StyledOpenIcon, StyledHighlight);
var StyledNote = (0, _styledComponents["default"])(_Note["default"]).withConfig({
  displayName: "TourSelectionForm__StyledNote",
  componentId: "sc-1wme9v3-14"
})(["border-top:1px solid #d9d9d9;font-size:14px;padding-top:13px;margin-top:15px;", "{color:#007aff;}"], _Note.StyledPlaceholder);
var StyledGoToLeadMailerIcon = (0, _styledComponents["default"])(_iconsReact.GoToLeadmailer).withConfig({
  displayName: "TourSelectionForm__StyledGoToLeadMailerIcon",
  componentId: "sc-1wme9v3-15"
})(["width:25px;height:24px;cursor:pointer;"]);
var _default = exports["default"] = TourSelectionForm;